export enum EskerStatus {
    // The initial status when a request is sent to Esker
    REQUEST_SENT = 'RequestSent',
    // The status when we are waiting for Esker to confirm receipt of the request
    PENDING_ESKER = 'PendingEsker',
    // The status when Esker confirms receipt of the request
    RECEIVED = 'Received',
    // The status when the request has been successfully processed in Esker and an SAP order number is generated -> the mdla request can be resolved
    SUCCESS = 'Success',
    // The status when the request has been rejected in Esker
    REJECTED = 'Rejected'
}
